import { render, staticRenderFns } from "./AboutLayout2.vue?vue&type=template&id=19dcdac2"
import script from "./AboutLayout2.vue?vue&type=script&lang=js"
export * from "./AboutLayout2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports